import { base64ToDataUrl } from "@isyc-react/archives";
import { useConfigurationContext } from "common-app/configuration/configuration.context";
import { FooterType } from "common/api/query/bailleurs-configuration/footer.query";
import React from "react";
export const useFooterConfiguration = (footerType) => {
    const { configuration } = useConfigurationContext();
    switch (footerType) {
        case FooterType.CONFIDENTIAL:
            return {
                text: 'Mentions légales',
                url: configuration === null || configuration === void 0 ? void 0 : configuration.confidentialUrl,
                hasArchive: configuration === null || configuration === void 0 ? void 0 : configuration.hasConfidentialUrl
            };
        case FooterType.HELP:
            return {
                text: 'Aide',
                url: configuration === null || configuration === void 0 ? void 0 : configuration.helpUrl,
                hasArchive: configuration === null || configuration === void 0 ? void 0 : configuration.hasHelpArchive
            };
        case FooterType.LEGAL_MENTIONS:
            return {
                text: 'Politiques de confidentialité',
                url: configuration === null || configuration === void 0 ? void 0 : configuration.legalMentionsUrl,
                hasArchive: configuration === null || configuration === void 0 ? void 0 : configuration.hasLegalMentionsArchive
            };
    }
};
export const useCristalImage = () => {
    const { configuration } = useConfigurationContext();
    return React.useMemo(() => {
        if (configuration === null || configuration === void 0 ? void 0 : configuration.cristalImage) {
            return base64ToDataUrl(configuration === null || configuration === void 0 ? void 0 : configuration.cristalImage.content, configuration === null || configuration === void 0 ? void 0 : configuration.cristalImage.format);
        }
        return undefined;
    }, [configuration === null || configuration === void 0 ? void 0 : configuration.cristalImage]);
};
